import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { FormHelperText } from "@mui/material";

export type DropdownProps = {
  label?: string;
  handleChange?: (
    event: SelectChangeEvent<string>,
    child: React.ReactNode
  ) => void;
  type?: string;
  value?: string;
  items: Array<{ id: number; name: string }>;
};

export default function Dropdown({
  label,
  handleChange,
  value,
  items,
}: DropdownProps) {
  return (
    <FormControl sx={{ minWidth: 120 }}>
      <Select
        value={value}
        IconComponent={() => null}
        onChange={handleChange}
        displayEmpty
        sx={{
          "& .MuiSelect-select": {
            padding: "8px !important",
            backgroundColor: "rgba(42, 148, 95, 1)",
            border: "1px solid rgba(42, 148, 95, 1)",
          },
        }}
        inputProps={{
          MenuProps: {
            MenuListProps: {
              sx: {
                backgroundColor: "rgba(42, 148, 95, 1) !important",
              },
            },
          },
        }}
      >
        {items.map((item, i) => {
          return (
            <MenuItem key={i} value={item.id}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
